import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import Lenis from 'lenis';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import '../../styles/theme.css';
import '../../styles/site.css';

/** Smooth scroll (Lenis), scroll to top / #hash on route change, reduced motion respected */
export default function Layout() {
    const { pathname, hash } = useLocation();
    const lenisRef = useRef(null);

    useEffect(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        lenisRef.current = lenis;
        let id;
        const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
        id = requestAnimationFrame(raf);
        return () => { cancelAnimationFrame(id); lenis.destroy(); lenisRef.current = null; };
    }, []);

    useEffect(() => {
        const go = () => {
            const target = hash ? document.querySelector(hash) : null;
            const lenis = lenisRef.current;
            if (target) {
                if (lenis) lenis.scrollTo(target, { offset: -90 });
                else window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 90 });
            } else if (lenis) lenis.scrollTo(0, { immediate: true });
            else window.scrollTo(0, 0);
        };
        const t = setTimeout(go, hash ? 80 : 0); // let the page render before scrolling to a section
        return () => clearTimeout(t);
    }, [pathname, hash]);

    return (
        <MotionConfig reducedMotion="user">
            <Navbar />
            <main id="main">
                <Outlet />
            </main>
            <Footer />
        </MotionConfig>
    );
}
